import { Injectable } from '@angular/core';

import { TODO } from '@b2b/types/core/utils';

/**
 * TerminalsService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/terminals/terminals.service.js
 * (legacy AngularJS name 'TerminalsService'). Static terminal-type catalogue
 * plus a lookup helper.
 *
 * Registered back into AngularJS under 'TerminalsService' via
 * downgradeInjectable in app/upgrade/ng-downgraded-components.ts.
 */
@Injectable({ providedIn: 'root' })
export class TerminalsService {
  types: TODO[] = [
    { name: 'pos', label: 'Point of Sale' },
    { name: 'kiosk', label: 'Kiosk' },
  ];

  init(): boolean {
    return true;
  }

  findType(type: string): TODO {
    let r: TODO = false;

    for (let i = 0, ii = this.types.length; i < ii; i++) {
      if (this.types[i].name === type) {
        r = {
          index: i,
          type: this.types[i],
        };
      }
    }

    return r;
  }
}
